// src/pages/Ads/components/PrivacyPolicyFull.jsx
import React from "react";

export default function PrivacyPolicyFull20251202() {
    return (
        <article className="prose prose-sm max-w-none">
            <header className="mb-4">
                <h2 className="text-lg font-bold">wizMarket 개인정보처리방침</h2>
                <p className="text-xs text-gray-500">본 개인정보처리방침은 제이예스 주식회사(이하 “회사”)가 제공하는 wizMarket (이하 “서비스”)에 적용되며, 「개인정보 보호법」 등 대한민국 관련 법령을 준수합니다. 본 방침은 서비스 내 고지와 함께 적용되며, 제·개정 시 사전 고지 절차를 따릅니다.</p>
            </header>

            <section>
                <h3 className="font-semibold">1. 총칙</h3>
                <p>
                    회사는 회원의 개인정보를 소중히 보호하며, 수집·이용 목적과 보유 기간, 제3자 제공 및 위탁, 이용자의 권리 행사 방법 등을 본 방침에 명확히 안내합니다. 회사는 서비스 제공에 필요한 최소한의 개인정보만을 처리합니다.
                </p>
            </section>

            <section>
                <h3 className="font-semibold py-2">2. 처리하는 개인정보의 항목 및 수집 방법</h3>
                <h4 className="font-medium mt-2">2-1. 수집 항목(필수/선택)</h4>
                <ul className="list-disc pl-5">
                    <li>
                        <ul className="list-[circle] pl-5">
                            <li><strong>(필수) 이름, 휴대전화번호, 외부 인증 제공자 식별자(예: sub/subject), 연동 계정 식별 정보(이메일/프로필 등 제공 동의 시), 휴대전화 본인인증 결과(인증기관: 코리아크레딧뷰로(KCB), CI/DI, 인증 시각, 통신사). 간편가입 제공자: Google, Apple, Kakao, Naver</strong></li>
                            <li><strong>(선택) 닉네임, 프로필 이미지, 사업자등록정보(상호, 대표자명, 사업자번호, 주소)</strong></li>
                            <li><strong>회사는 별도의 아이디/비밀번호를 발급·저장하지 않습니다. 로그인은 외부 인증 제공자(OAuth/OIDC) 및 휴대전화 본인인증(KCB 본인확인기관 연동)으로 이루어집니다.</strong>`</li>
                        </ul>
                    </li>
                    <li>

                        <ul className="list-[circle] pl-5">
                            <li>•	<strong>결제/정산</strong> : 결제 수단 식별 정보(카드사/간편결제 식별자, 거래승인번호, 결제계정 ID 등), 청구/환불 이력, 세금계산서 정보(사업자명, 번호, 주소)</li>
                            <li>※ 결제는 PG사를 통해 처리되며, 카드번호 등 민감 정보는 회사가 직접 보관하지 않습니다.</li>
                        </ul>
                    </li>
                    <li>

                        <ul className="list-[circle] pl-5">
                            <li>
                                • <strong>서비스 이용</strong> : 접속 일시, IP, 기기/브라우저 정보, 쿠키·유사 식별자,
                                <strong>토큰 부여·차감 이력</strong>,
                                생성/업로드 파일의 메타데이터(파일명, 포맷, 용량, 해시값 등),
                                채널 연동 정보(채널 계정 식별자, 액세스/갱신 토큰—암호화 저장), 오류/크래시 로그
                            </li>
                        </ul>

                    </li>
                    <li>•	<strong>고객센터/권리침해 신고</strong>: 문의·신고 내용, 연락처, 증빙자료(권리 증명서류, 위임장 등)</li>
                    <li>•	<strong>이벤트/프로모션(선택)</strong>: 참여 내역, 배송지(경품), 수령자 정보</li>
                    <li>•	<strong>법령상 보관</strong>: 전자상거래 등 소비자보호 관련 기록(계약·결제·민원 등)</li>
                    <li>•	<strong>마케팅(선택)</strong>:  이메일, 휴대전화번호, 앱 푸시 토큰, 수신 채널 종류, 수신동의/철회 일시·경로(증빙용), 야간(21:00~08:00) 수신 동의 여부※ 법정 고지(약관 변경, 보안, 결제·장애 안내)는 마케팅 동의와 무관하게 발송될 수 있음</li>
                    <li>    ※ 법정 고지(약관 변경, 보안, 결제·장애 안내)는 마케팅 동의와 무관하게 발송될 수 있음</li>
                </ul>

                <h4 className="font-medium mt-2">2-2. 수집 방법</h4>
                <ul className="list-disc pl-5">
                    <li>•	회원가입/로그인 과정에서 다음 정보를 수집합니다</li>
                    <li>•	외부 인증 제공자(OAuth/OIDC: Google, Apple, Kakao, Naver)의 동의 화면</li>
                    <li>•	KCB 휴대전화 본인인증 결과(CI/DI 등)</li>
                    <li>•	필수 정보인 ‘이름·휴대전화번호’는 회원이 직접 입력하거나 본인인증 결과 기반으로 수집</li>
                    <li>•	서비스 이용 과정에서 자동 수집되는 정보(쿠키, 로그 등)</li>
                </ul>

                <h4 className="font-medium mt-2">2-3. 외부 인증 제공자 연동 안내</h4>
                <ul className="list-disc pl-5">
                    <li>•	회사는 외부 인증 제공자에 회원의 개인정보를 <strong>별도로 제공하지 않으며</strong>, 간편가입·로그인을 위해 필요한 범위에서만 정보를 처리합니다. 각 제공자의 개인정보처리방침·보안정책은 해당 사업자가 정한 기준에 따릅니다.</li>
                    <li>•	회원은 <strong>설정 &gt; 계정</strong>에서 연동된 인증 제공자를 확인·추가·해제할 수 있으며, <strong>계정 유지에는 최소 1개의 인증 수단이 필요</strong> 합니다. 모든 인증 수단을 해제할 경우 <strong>탈퇴로 처리</strong>될 수 있습니다.</li>
                </ul>
                <h4 className="font-medium mt-2">2-4. 주민등록번호 처리 제한</h4>
                <ul className="list-disc pl-5">
                    <li>•	회사는 주민등록번호 전체를 <strong>수집·저장·처리하지 않습니다.</strong> 본인확인은 <strong>KCB 인증 서비스에서 직접 수집·처리</strong>되며, 회사는 주민등록번호를 <strong>수신하지 않습니다.</strong></li>
                    <li>•	회사는 본인확인용 <strong>결과값(CI/DI, 인증 시각, 인증 성공 여부 등)</strong>만 처리하며, 목적 달성 후 관련 법령에 따라 보관·파기합니다.</li>
                </ul>
            </section>

            <section>
                <h3 className="font-semibold py-2">3. 개인정보의 처리 목적</h3>
                <ul className="list-disc pl-5">
                    <li>•	회사는 다음 목적을 위해 개인정보를 처리합니다:</li>
                    <li>•	회원 식별 및 고객센터 1:1 문의 대응(실명·연락처 확인 포함)</li>
                    <li>•	계약의 체결·이행, 유료 서비스 제공</li>
                    <li>•	토큰 관리(부여/차감/정산)</li>
                    <li>•	결제/환불 및 회계 처리</li>
                    <li>•	부정 사용 방지 및 보안·안정성 확보</li>
                    <li>•	외부 채널 연동 제공 및 유지</li>
                    <li>•	서비스 품질/이용성 개선(익명·가명 처리)</li>
                    <li>•	법령 준수 및 관계기관 요청 이행</li>
                    <li>회사는 회원 식별, 계정 보호, 고객센터 1:1 문의 대응, 분쟁 처리 등 서비스 제공에 필수적인 경우에 한하여 이름과 휴대전화번호를 필수 항목으로 수집합니다.</li>
                </ul>
            </section>

            <section>
                <h3 className="font-semibold py-2">4. 보유 및 이용 기간</h3>
                <ul className="list-disc pl-5">
                    <li>•	<strong>회원계정 정보</strong>: 탈퇴 시까지(휴면전환 시 분리 보관), 분쟁 대비를 위해 최대 3년 추가 보관 가능</li>
                    <li>•	<strong>계약/청약철회/결제/정산 기록</strong>: 5년 (전자상거래법)</li>
                    <li>•	<strong>소비자 불만·분쟁처리 기록</strong>: 3년 (전자상거래법)</li>
                    <li>•	<strong>표시/광고 기록</strong>: 6개월 (전자상거래법)</li>
                    <li>•	<strong>접속 로그(IP 포함)</strong>: 3개월 (통신비밀보호법)</li>
                    <li>•	<strong>권리침해 신고/처리 기록</strong>: 최대 1년(운영정책)</li>
                    <li>•	<strong>채널·인증 연동 정보</strong>: 회원 해제 또는 연동 종료 시 즉시 파기</li>
                </ul>
            </section>

            <section>
                <h3 className="font-semibold py-2">5. 개인정보의 제3자 제공</h3>
                <p>회사는 원칙적으로 회원의 개인정보를 제3자에게 <strong>제공하지 않습니다.</strong> 다만, 다음의 경우 예외적으로 제공할 수 있습니다. - 회원의 <strong>사전 동의</strong>가 있는 경우 - 법령에 근거하거나 수사·감독기관의 적법한 요구가 있는 경우</p>
            </section>

            <section>
                <h3 className="font-semibold py-2">6. 개인정보 처리의 위탁</h3>
                <p>안정적인 서비스 제공을 위하여 일부 업무를 외부에 위탁할 수 있습니다. 위탁 시 계약을 통해 개인정보 보호 의무를 부과하고 관리·감독합니다.</p>

                {/* 표 스타일을 위해 테일윈드 유틸리티 사용 */}
                <div className="overflow-auto border rounded-md my-2">
                    <table className="min-w-full text-sm">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-3 py-2 text-left font-semibold border-b">수탁자</th>
                                <th className="px-3 py-2 text-left font-semibold border-b">위탁업무</th>
                                <th className="px-3 py-2 text-left font-semibold border-b">보유·이용기간</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="border-b">
                                <td className="px-3 py-2">나이스페이먼츠(주) (NICE Payments Co., Ltd.)</td>
                                <td className="px-3 py-2">결제 처리, 환불/정산</td>
                                <td className="px-3 py-2">법정 보관기간 후 파기</td>
                            </tr>
                            <tr className="border-b">
                                <td className="px-3 py-2">Alibaba Cloud</td>
                                <td className="px-3 py-2">인프라 제공 및 데이터 저장(리전: 국내 사용 기준)</td>
                                <td className="px-3 py-2">회원 탈퇴·계약 종료 시 또는 위탁계약 종료 시</td>
                            </tr>
                            {/* <tr className="border-b">
                <td className="px-3 py-2">[로그/모니터링 사업자(수정 필요)]</td>
                <td className="px-3 py-2">로그 수집·분석, 장애 대응</td>
                <td className="px-3 py-2">목적 달성 시</td>
              </tr> */}
                            <tr>
                                <td className="px-3 py-2">코리아크레딧뷰로(KCB)</td>
                                <td className="px-3 py-2">본인확인(CI/DI 발급·검증), 연령/실명 확인</td>
                                <td className="px-3 py-2">법정 보관기간 후 파기</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <p className="text-xs text-gray-500 mt-2">
                    실제 사용 중인 수탁자 명칭·연락처·국가(국외 이전 시)를 확정하는 즉시 반영합니다.
                </p>
            </section>

            <section>
                <h3 className="font-semibold py-2">7. 국외 이전에 관한 사항</h3>
                <p>
                    •	<strong>현행 운영 기준(국내 리전 사용)</strong>: 회사는 서비스 제공에 필요한 개인정보를 <strong>국내에서만 처리</strong>하며, <strong>국외로 이전하지 않습니다.</strong> 클라우드/IaaS는 <strong>Alibaba Cloud의 국내 리전</strong>을 사용합니다. 향후 국외 리전 사용,
                    해외 인력의 원격 접근, 해외 분석·발송 도구 도입 등 <strong>국외 이전이 필요한 변경</strong>이 발생하는 경우, 「개인정보 보호법」에 따라 <strong>수령자·국가·이전 항목·목적·보유기간·동의 철회 방법</strong> 등을 <strong>사전 고지하고 동의</strong>를 받은 후 진행합니다.
                </p>
                <h4>•	국외 리전/원격접속 사용 시</h4>
                <ul className="list-disc pl-5">
                    <li>o	<strong>이전받는 자(수탁자)</strong>: Alibaba Cloud (Singapore) Pte. Ltd. / Alibaba Cloud Computing Ltd. (계약 주체에 따름)</li>
                    <li>o	<strong>이전 국가</strong>: 싱가폴, 쿠알라룸푸르, 자카르타, 마닐라, 방콕, 도쿄, 뭄바이</li>
                    <li>o	<strong>이전 일시·방법</strong>: 서비스 이용 시점의 <strong>네트워크 전송(상시)</strong>, 백업·DR 시 <strong>주기 전송</strong></li>
                    <li>o	<strong>이전 항목</strong>: 회원 식별 정보(계정 식별자, CI/DI 등), 서비스 이용기록(접속 로그/IP/디바이스), <strong>토큰 부여·차감 이력</strong>, 업로드 파일 메타데이터,
                        채널 연동 정보(액세스/갱신 토큰—암호화 저장), 오류/크래시 로그 등 <strong>서비스 제공에 필요한 최소 항목</strong></li>
                    <li>o	<strong>이용 목적</strong>: 인프라 제공(저장·호스팅·백업), 보안·장애 대응, 로그 수집·분석</li>
                    <li>o	<strong>보유·이용기간</strong>: 위탁(계약) 기간 내 또는 목적 달성 시까지, 법령상 보관기간 경과 후 파기</li>
                    <li>o	<strong>동의 철회/국외 이전 중단 요청</strong>: 설정 - 개인정보 또는 고객센터로 요청 가능 (필수 인프라 변경 시 서비스 제공이 제한될 수 있음)</li>
                </ul>
            </section>

            <section>
                <h3 className="font-semibold  py-2">8. 쿠키 및 유사 기술의 이용</h3>
                <ul className="list-disc pl-5">
                    <li>• 회사는 로그인 유지, 설정 저장, 이용 통계 분석 및 맞춤형 기능 제공을 위해 <strong>쿠키</strong>를 사용할 수 있습니다.</li>
                    <li>•	이용자는 브라우저 설정에서 쿠키 저장을 거부하거나 삭제할 수 있으나, 일부 기능 이용에 제한이 있을 수 있습니다.</li>
                </ul>
            </section>

            <section>
                <h3 className="font-semibold  py-2">9. 개인정보의 파기 절차 및 방법</h3>
                <ul className="list-disc pl-5">
                    <li>•	파기 사유가 발생한 개인정보는 <strong>지체 없이 파기</strong>합니다.</li>
                    <li>•	<strong>전자적 파일</strong>: 복구·재생이 불가능한 방법으로 영구 삭제</li>
                    <li>•	<strong>종이 문서</strong>: 분쇄 또는 소각</li>
                    <li>•	<strong>별도 저장 후 파기</strong>: 일부 정보는 법령상 보관 의무에 따라 별도 저장 후 기간 경과 시 파기합니다.</li>
                </ul>

                <h4 className="font-medium mt-2">9-1. 회원 탈퇴(계정 삭제) 시 개인정보 처리</h4>
                <ul className="list-disc pl-5">
                    <li>•	회원이 <strong>계정 탈퇴</strong>를 요청하는 경우, 회사는 지체 없이 회원의 개인정보를 <strong>파기</strong>하거나 법령상 보관이 필요한 정보는 별도 분리·보관 후 보관기간 경과 시 파기합니다.</li>
                    <li>•	파기 또는 분리·보관 대상: 계정 식별 정보, 프로필·연락처, <strong>부 인증 제공자 연동 정보</strong>외(OAuth/OIDC 식별자, 액세스/리프레시 토큰 등), 채널 연동 정보,
                        결제 이력 및 영수증/세금계산서 정보(법정 보관기간 적용), 고객센터/권리침해 신고 기록(운영정책 또는 법령상 보관기간 적용), 서비스 이용 로그(통신비밀보호법상 기간 적용) 등.</li>
                    <li>•	<strong>예외 보관</strong>: 「전자상거래 등에서의 소비자보호에 관한 법률」, 「통신비밀보호법」 등 관계 법령에 따른 <strong>계약·결제·민원 기록, 접속기록</strong> 등은 정해진 기간 동안 보관 후 파기합니다(제4조 ‘보유 및 이용 기간’ 참조).</li>
                    <li>•	<strong>백업 보관</strong>: 시스템 백업의 특성상 일부 정보가 백업 저장소에 일정 기간 잔존할 수 있으며, 이 경우 해당 정보에는 <strong>업무상 접근이 제한</strong>되고, 주기적 순환 백업·만료 정책에 따라 <strong>복구 불가 상태로 영구 삭제</strong>됩니다.</li>
                    <li>•	<strong>인증·채널 연동 해제</strong>: 탈퇴 시 회사는 외부 <strong>인증 제공자</strong> 및 외부 <strong>채널</strong>과의 연동 권한을 철회하고, 저장된 인증·채널 관련 정보를 삭제합니다. 회원은 각 사업자의 보안 설정에서 <strong>앱 접근 권한 철회</strong> 여부를 추가 확인할 수 있습니다.</li>
                    <li>•	<strong>학습 데이터 관련</strong>: 회사는 원본 콘텐츠를 기본적으로 <strong>모델 학습에 사용하지 않으</strong>며(제13조 참조), 회원이 과거에 <strong>Opt-in 동의</strong>한 경우 탈퇴·철회 요청 시 <strong>추가 수집을 중단</strong>하고 가능한 범위에서 <strong>데이터셋에서 제거 또는 비식별화</strong>를 진행합니다.</li>
                    <li>•	<strong>데이터 내보내기(선택)</strong>: 회원은 탈퇴 전에 본인의 주요 정보를 <strong>기계 판독 가능한 형태</strong>로 열람/사본 제공을 요청할 수 있으며, 회사는 관련 법령 및 기술적 한도 내에서 지원합니다.</li>
                </ul>
            </section>

            <section>
                <h3 className="font-semibold  py-2">10. 이용자 및 법정대리인의 권리와 행사 방법</h3>
                <ul className="list-disc pl-5">
                    <li>•	이용자는 자신의 개인정보에 대해 <strong>열람·정정·삭제·처리정지</strong>를 요구할 수 있습니다.</li>
                    <li>•	앱/웹의 설정 화면 또는 고객센터(이메일/상담 채널)를 통해 신청하실 수 있으며, 회사는 <strong>지체 없이</strong> 조치합니다(신분 확인 필요). 법령상 보관이 필요한 정보는 삭제가 제한될 수 있습니다.</li>
                    <li>•	만 14세 미만 아동의 경우 원칙적으로 회원 가입을 허용하지 않습니다. 불가피한 처리 시에는 법정대리인의 <strong>동의 확인</strong> 절차를 거칩니다.</li>
                    <li>•	서비스는 원칙적으로 만 19세 이상의 성인 이용자를 대상으로 하며, 만 14세 이상~19세 미만 이용자의 경우 회원가입은 가능하더라도 유료 결제는 제한될 수 있습니다(이용약관 참조).</li>
                </ul>
            </section>

            <section>
                <h3 className="font-semibold  py-2">11. 자동화된 처리 및 프로파일링 관련 안내</h3>
                <ul className="list-disc pl-5">
                    <li>•	서비스는 이미지 <strong>생성·보정 등 자동화된 처리</strong>를 포함하나, 개인의 법적 권리 또는 중대한 영향을 미치는 <strong>자동 의사결정</strong>을 단독으로 수행하지 않습니다.</li>
                    <li>•	맞춤 추천 등 편의 기능은 <strong>통계·가명 처리된 정보</strong>를 활용하며, 이용자는 설정에서 맞춤형 알림/마케팅 수신을 거부할 수 있습니다.</li>
                </ul>
            </section>

            <section>
                <h3 className="font-semibold  py-2">12. 개인정보의 안전성 확보 조치</h3>
                <ul className="list-disc pl-5">
                    <li>•	<strong>내부관리계획 수립·시행</strong>, 최소 권한 부여, 정기 보안 교육</li>
                    <li>•	<strong>전송구간 암호화(HTTPS/TLS)</strong>, 저장 시 암호화(중요 정보), 비밀번호 일방향 해시</li>
                    <li>•	<strong>접속기록의 위·변조 방지 및 보관</strong>, 이상 징후 모니터링</li>
                    <li>•	<strong>물리적 접근 통제(데이터센터/IaaS IAM)</strong>, 백업 및 복구체계 운영</li>
                    <li>•	<strong>수탁자 관리·감독</strong> 및 정기 점검</li>
                </ul>
            </section>

            <section>
                <h3 className="font-semibold  py-2">13. 데이터 학습 및 품질 고도화에 관한 특칙</h3>
                <ul className="list-disc pl-5">
                    <li>•	회사는 회원의 <strong>원본 콘텐츠를 인공지능 모델 학습(재학습) 목적으로 사용하지 않습니다.</strong></li>
                    <li>•	회원이 <strong>명시적으로 동의(Opt-in)</strong>하는 경우에 한해 학습 데이터로 활용할 수 있으며, 언제든지 <strong></strong>동의를 철회할 수 있습니다. 철회 시 추가 수집을 중단하고 가능한 범위에서 데이터셋에서의 제거·비식별화를 진행합니다.</li>
                    <li>•	서비스 품질·보안 향상을 위한 <strong>로그·메타데이터</strong>는 익명·통계 처리 범위에서 활용할 수 있습니다.</li>
                </ul>
            </section>

            <section>
                <h3 className="font-semibold  py-2">14. 개인정보 보호책임자(CPO) 및 담당 부서</h3>
                <ul className="list-disc pl-5">
                    <li>•	<strong>개인정보 보호책임자(CPO): [정광재] / [실장] / [slaggy@jyes.co.kr] / [02-2655-9603]</strong></li>
                    <li>•	<strong>개인정보 민원 처리 담당부서: [CS] / [slaggy@jyes.co.kr] / [02-2655-9603]</strong></li>
                </ul>
            </section>

            <section>
                <h3 className="font-semibold  py-2">15. 권리침해 구제 방법</h3>
                <p>개인정보 침해에 대한 신고나 상담이 필요하신 경우 다음 기관에 문의할 수 있습니다. - 개인정보침해신고센터(한국인터넷진흥원) 국번없이 118 - 개인정보분쟁조정위원회 - 대검찰청 사이버수사과 - 경찰청 사이버범죄 신고시스템</p>
            </section>

            <section>
                <h3 className="font-semibold  py-2">16. 방침의 변경 및 고지</h3>
                <ul className="list-disc pl-5">
                    <li>•	본 방침은 시행일로부터 적용됩니다.</li>
                    <li>•	회사는 관련 법령, 서비스 변경에 따라 방침을 개정할 수 있으며, <strong>중요 변경 시 최소 7일 전(회원에게 중대한 변경은 30일 전) 사전 고지</strong>합니다.</li>
                    <li><strong>시행일: 2025-12-09</strong></li>
                </ul>
            </section>

            <section>
                <h3 className="font-semibold  py-2">17. 개인정보의 유효기간 제도(휴면계정)</h3>
                <p>회사는 12개월 이상 로그인 등 이용이 없는 회원의 개인정보를 <strong>분리 보관</strong>하며, 분리 보관 예정 30일 전에 이메일 등으로 통지합니다. 휴면 해제는 재로그인 또는 고객센터 요청으로 가능합니다.</p>
            </section>

            <section>
                <h3 className="font-semibold  py-2">18.마케팅 정보 수신동의(선택) 및 광고성 정보 전송</h3>
                <ul className="list-disc pl-5">
                    <li>•	회사는 회원의 사전 동의가 있는 경우에 한하여, 이메일·SMS/MMS·카카오(알림톡·친구톡 등)·앱 푸시 등으로 혜택·이벤트·프로모션, 신기능/이용 가이드 등 광고성 정보를 전송할 수 있습니다. 마케팅 수신동의는 선택 사항으로서, 서비스 기본 이용의 필수 조건이 아닙니다.</li>
                    <li>•	야간(21:00~08:00)시간대 전송은 관계 법령상 별도의 사전 동의가 필요한 매체에 한하여전송하며, 회사는 법령에 따른 표시 의무(“(광고)” 표기, 발신자명·연락처, 수신거부 방법)를 준수합니다.</li>
                    <li>• 회원은 설정 ▷ 알림/마케팅에서 채널별 개별 동의/철회를 할 수 있으며, 각 메시지 하단의 수신거부(UNSUBSCRIBE) 수단을 통해서도 언제든지 철회할 수 있습니다.
                        회사는 철회 요청을 지체 없이 반영합니다(기술적 처리에 필요한 최소 시간이 소요될 수 있음).<span className="text-gray-500">2025-09-22</span></li>
                    <li>• 회사는 관련 법령 및 가이드라인에 따라 수신동의 상태를 주기적으로 재확인할 수 있습니다(예: 2년 주기 리마인드).</li>
                    <li>• 마케팅 목적을 위한 개인정보의 처리 항목, 보유 기간, 동의·철회 방법등 세부 사항은 본 개인정보처리방침 2·3·4항을 따릅니다. 수신동의/철회 이력은 분쟁 대응 및 법령 준수 증빙을 위해 필요 최소 기간동안 보관할 수 있습니다.</li>
                </ul>
            </section>
        </article>
    );
}
